/* eslint-disable camelcase */
import useAnalytics from "@/core/plugins/analytics/useAnalytics";
import useStorage from "@/core/plugins/useStorage";
import { useRouter } from "vue-router";
import { event } from "vue-gtag";
import {
  F360Product,
  IUserProfile,
  LocalStorageKeys,
  IFranqueadores
} from "@/core/@types/types";

const categoria = "Dash Bob's";

export enum AnalyticsDahsBobsEvents {
  acessarDashBobBanner = "Dashbob's_Banner",
  acessarDashBobVideo = "Dashbob's_Vídeo",
  acessarDashBobMenu = "Dashbob's_Menu"
}

// Função auxiliar para enviar analytics sem depender do Router Vue
const sendDashBobsAnalyticsEvent = (eventName: string) => {
  const storage = useStorage();
  const user = storage.get<IUserProfile>(LocalStorageKeys.UserProfile);

  const findFranqueador = (franqueadores: IFranqueadores[]): string => {
    if (!franqueadores) return "";

    const nomes = franqueadores.map(
      (franqueador) => franqueador?.Franqueador?.Value?.Nome
    );

    return nomes.join("; ");
  };

  // Monta os dados customizados igual ao useAnalytics
  const customDimensions = {
    user_email: user?.Email || "",
    user_grupo: user?.Grupo || "",
    page_location: window.location.href,
    page_path: window.location.pathname,
    page_name: document.title,
    produto_financas: F360Product.Financas,
    grupo_codigo: user?.CodigoCliente || "",
    grupo_franqueadores:
      findFranqueador(
        (user?.Franqueadores as unknown as IFranqueadores[]) || []
      ) || "",
    grupo_id: user?._id || "",
    grupo_marcas: user?.Marcas?.join("; ") || "",
    grupo_nome: user?.Nome || "",
    grupo_qtd_empresas: user?.QtdEmpresa || 0,
    grupo_tipo_perfil: user?.Perfil || "",
    usuario_adm: user?.PerfilAdm || "",
    usuario_email: user?.Email || "",
    usuario_id: user?._id || "",
    usuario_nome: user?.Nome || "",
    usuario_pagina_inicial: user?.PaginaInicial || ""
  };

  event(eventName, {
    event_category: categoria,
    ...customDimensions
  });
};

export default function useDahsBobsAnalytics() {
  const router = useRouter();
  const storage = useStorage();
  const analytics = useAnalytics(storage, router);

  const acessarDashBobBannerAnalytics = () => {
    analytics.sendEvent(categoria, AnalyticsDahsBobsEvents.acessarDashBobBanner);
  };

  const acessarDashBobVideoAnalytics = () => {
    analytics.sendEvent(categoria, AnalyticsDahsBobsEvents.acessarDashBobVideo);
  };

  const acessarDashBobMenuAnalytics = () => {
    analytics.sendEvent(categoria, AnalyticsDahsBobsEvents.acessarDashBobMenu);
  };

  return {
    acessarDashBobBannerAnalytics,
    acessarDashBobVideoAnalytics,
    acessarDashBobMenuAnalytics
  };
}

export const sendDashBobMenuAnalytics = () => {
  sendDashBobsAnalyticsEvent(AnalyticsDahsBobsEvents.acessarDashBobMenu);
};
